module.exports = __webpack_public_path__ + "b58bbf96869d799e1be4a600e6fec20d.woff";